export const resolveRestoredStep = ({
  localStep,
  remoteStep,
  maxRestorableStep,
  totalSteps
}: {
  localStep: number
  remoteStep: number | null
  maxRestorableStep: number | null
  totalSteps: number
}) => {
  const normalizedLocalStep =
    Number.isFinite(localStep) && localStep >= 0 ? Math.min(localStep, totalSteps) : 0
  const normalizedRemoteStep =
    typeof remoteStep === 'number' && Number.isFinite(remoteStep) && remoteStep >= 0
      ? Math.min(remoteStep, totalSteps)
      : null

  const restoredStep =
    normalizedRemoteStep === null
      ? normalizedLocalStep
      : Math.max(normalizedLocalStep, normalizedRemoteStep)

  return typeof maxRestorableStep === 'number'
    ? Math.min(restoredStep, maxRestorableStep)
    : restoredStep
}
